import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TicketService } from 'src/app/features/events/services/ticket.service';
import getMobileOS from 'src/app/core/functions/getMobileOS';
import MobileOs from 'src/app/core/enums/mobile-os';

@Component({
  selector: 'app-wallet-passes',
  templateUrl: './wallet-passes.component.html',
  styleUrls: ['./wallet-passes.component.css'],
})
export class WalletPassesComponent implements OnInit {
  isLoading = false;
  isVisible = false;
  
  public actionImg = '';
  public bg = 'background:';

  @Input()
  slug!: string;

  @Output() visibilityChange = new EventEmitter<boolean>();

  constructor(private ticketsService: TicketService) {}

  ngOnInit(): void {
    const os = getMobileOS();

    if (os === MobileOs.IOS) {
      this.actionImg = 'assets/img/apple_Wallet_Icon.png';
      this.bg += '#000';
      this.isVisible = true;
    } else if (os === MobileOs.Android) {
      this.actionImg = 'assets/img/add-to-google-wallet.png';
      this.bg += '#191919';
      this.isVisible = true;
    }
    this.visibilityChange.emit(this.isVisible);
  }

  async addToWallet() {
    const type = this.actionImg.includes('google') ? 'google' : 'apple';

    this.isLoading = true;
    try {
      const response = await this.ticketsService.addToWallet(this.slug, type);
      if (type === 'apple') {
        this.addToAppleWallet(response);
      } else if (type === 'google') {
        this.addToGoogleWallet((response as any)?.saveUrl);
      }
    } catch (error) {
      console.error('UNEXPECTED ERROR ADDING TO WALLET: ', error);
    } finally {
      this.isLoading = false;
    }
  }

  private async addToGoogleWallet(saveUrl?: string) {
    if (!document || !saveUrl) return;

    const link = document.createElement('a');
    link.href = saveUrl;
    link.click();

    link.remove();
    URL.revokeObjectURL(link.href);
  }

  private async addToAppleWallet(passes?: any) {
    if (!document || !passes) return;
    const link = document.createElement('a');

    const file = new Blob([passes], { type: 'application/vnd.apple.pkpasses' });
    link.href = URL.createObjectURL(file);
    link.download = 'event.pkpasses';
    link.click();
    URL.revokeObjectURL(link.href);
  }
}